import { render } from "./MedauHeader.vue?vue&type=template&id=54fa274b"
import script from "./MedauHeader.vue?vue&type=script&lang=js"
export * from "./MedauHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__